import React from 'react';

import { observer, inject } from 'mobx-react';
import moment from 'moment';
import { CircularProgress } from 'material-ui/Progress';

import HeaderDashboard from '../components/HeaderDashboard';
import SideMenu from '../components/SideMenu';
import FilterListItem from "../components/Dashboard/FilterListItem";

class DashboardContainer extends React.Component {

    /* constructor(props) {
        super(props);
    } */

    componentDidMount() {
        this.fetchData();

        const dashboard_store = this.props.dashboard_store;

        setInterval(()=> {
            this.fetchData();
        }, dashboard_store.time_to_sync)
    }

    fetchData() {
        const dashboard_store = this.props.dashboard_store;
        dashboard_store.fetch();
    }

    showStatusLoading() {

        const dashboard_store = this.props.dashboard_store;
        const items = dashboard_store.getItemsLoading();

        return (
            items.map((item, index)=> {
                return (<FilterListItem key={index} vehicle={item} />)
            })
        )
    }

    showStatusOnRoute() {

        const dashboard_store = this.props.dashboard_store;
        const items = dashboard_store.getItemsOnRoute();

        return (
            items.map((item, index)=> {
                return (<FilterListItem key={index} vehicle={item} />)
            })
        )
    }

    showStatusDeliveryProcess() {

        const dashboard_store = this.props.dashboard_store;
        const items = dashboard_store.getItemsDeliveryProcess();

        return (
            items.map((item, index)=> {
                return (<FilterListItem key={index} type={'delivery_process'} vehicle={item} />)
            })
        )
    }

    update() {
        const dashboard_store = this.props.dashboard_store;
        dashboard_store.is_fetched = false;

        this.fetchData();
    }

    render() {
        const dashboard_store = this.props.dashboard_store;
        const updated_at = dashboard_store.updated_at;

        return (
            <div>
                <HeaderDashboard update={this.update.bind(this)} />

                <div className="container-fw">

                    <SideMenu />

                    <div className="content">
                    {
                        !dashboard_store.is_fetched ?
                            <div className="flex-container">
                                <div className="text-center" style={{marginTop: '36px'}}>
                                    <div><CircularProgress /></div>
                                    <p><small>Carregando...</small></p>
                                </div>
                            </div>
                            :

                            <div className="flex-container">
                            <p className={'update-status'}>
                                {'Última atualização em: \n'}
                                <span>{moment(updated_at).format('DD/MM/YYYY HH:mm')}</span>
                            </p>
                            <div className="filter-nav" style={{'justifyContent': 'space-evenly'}}>
                                <div className={'filter'}>
                                    <h4 className={'filter-title'}><i className="material-icons">unarchive</i>
                                        CARREGANDO ({dashboard_store.vehicles.loading && dashboard_store.vehicles.loading.length})
                                    </h4>

                                    { this.showStatusLoading() }

                                </div>
                                <div className={'divider'}></div>
                                <div className={'filter'}>
                                    <h4 className={'filter-title'}><i className="material-icons">local_shipping</i>
                                        EM ROTA ({dashboard_store.vehicles.on_route && dashboard_store.vehicles.on_route.length})
                                    </h4>

                                    { this.showStatusOnRoute() }
                                </div>
                                <div className={'divider'}></div>
                                <div className={'filter'}>
                                    <h4 className={'filter-title'}><i className="material-icons">archive</i>
                                        EM PROCESSO DE ENTREGA ({dashboard_store.vehicles.delivery_process && dashboard_store.vehicles.delivery_process.length})
                                    </h4>

                                    { this.showStatusDeliveryProcess() }
                                </div>
                            </div>
                            </div>

                    }

                    </div>
                </div>
            </div>
        );
    }

}

let container = observer(DashboardContainer);
container = inject(['dashboard_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/containers/dashboard.js